// extracted by mini-css-extract-plugin
export var actionButton = "_fp-0";
export var fileInput = "_fp-2";
export var paperclip = "_fp-1";